import { render, staticRenderFns } from "./NicheOverview.vue?vue&type=template&id=560266f2"
import script from "./NicheOverview.vue?vue&type=script&lang=js"
export * from "./NicheOverview.vue?vue&type=script&lang=js"
import style0 from "./NicheOverview.vue?vue&type=style&index=0&id=560266f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports